// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3pTmu","info":"UpdateTermsInfo_info__-BXv_"};